export const ATUALIZADO = 'Usuário atualizado'
export const CADASTRADO = 'Usuário adicionado'
export const NAO_ENCONTRADO = 'Não foram encontrados usuários cadastrados'
export const NAO_ENCONTRADO_FILTRO = 'Não há usuários com esse filtro'

export const EXISTEM_HORARIOS_MARCADOS = 'Há conflitos de horários no dia marcado'
export const SENHA_RESETADA = 'Senha resetada com sucesso'
